import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css"; // same style file as MerchantDetails
import AppButton from "../../Components/MerchantButton";
import { getRegionConfig } from "./config/regionConfig";
function MayaMallProgramSection70({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});
  const [regionConfig, setRegionConfig] = useState(null);
  
  // Initialize regionConfig when component mounts
  useEffect(() => {
    if (primaryDetails?.region) {
      setRegionConfig(getRegionConfig(primaryDetails.region));
    }
  }, [primaryDetails?.region]);

  
  const reasonOptions = [
    "Management Restriction",
    "HO Restriction",
    "Defective Maya terminal and/or static QR",
    "Terminal Pull-out",
    "Authorized person is not available",
    "Undecided - for revisit",
    "Competitor's  Priority",
    "Not Migrated (Applicable for DCC only)",
    "Maya SQR only  (Appilcable for DCC only)",
    // "Needs email exchange between Maya and HQ",
    // "Non Maya Merchant",
    "Other reason"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (isError[name]) {
      setIsError((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!primaryDetails.joined_maya_program) {
      errors.joined_maya_program = true;
    }

    // If answer is "No", require a reason
    if (primaryDetails.joined_maya_program === "No" && !primaryDetails.not_joined_maya_program_reason) {
      errors.not_joined_maya_program_reason = true;
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    if (!primaryDetails.joined_maya_program) {
      return false;
    }

    if (primaryDetails.joined_maya_program === "No" && !primaryDetails.not_joined_maya_program_reason) {
      return false;
    }

    return true;
  };
  const handleNext = () => {
    if (validateForm()) {
      // If regionConfig is not loaded yet, try to load it
      if (!regionConfig && primaryDetails?.region) {
        const config = getRegionConfig(primaryDetails.region);
        setRegionConfig(config);
        
        const joined_maya_program = primaryDetails[config.formFields.joined_maya_program] || primaryDetails.joined_maya_program;
        
        if (joined_maya_program === "Yes, CIP with DCC" || joined_maya_program === "Yes, DCC only") {
          navigation.go("joining-maya-mall-program-section-72");
        } else {
          navigation.go("competitor-priority");
        }
      } else {
        const joined_maya_program = regionConfig 
          ? primaryDetails[regionConfig.formFields.joined_maya_program] || primaryDetails.joined_maya_program
          : primaryDetails.joined_maya_program;
        
        if (joined_maya_program === "Yes, CIP with DCC" || joined_maya_program === "Yes, DCC only") {
          navigation.go("joining-maya-mall-program-section-72");
        } else {
          navigation.go("competitor-priority");
        }
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">ASK IF JOINING MAYA MALL PROGRAM</h4>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                 

                  {/* Join Maya Mall Program */}
                  <Form.Group className="mb-5" controlId="joined_maya_program">
                    <Form.Label className="form-label">
                      Ask if merchant wants to join the Maya Mall Program <span className="form-required">*</span>
                    </Form.Label>

                    <Form.Select
                      name="joined_maya_program"
                      value={primaryDetails.joined_maya_program || ""}
                      onChange={handleInputChange}
                      className={`form-input ${isError.joined_maya_program ? "form-input-error" : ""}`}
                    >
                      <option value="">-- Select an option --</option>
                      {/* <option value="Yes">Yes</option> */}
                      <option value="Yes, CIP with DCC">Yes, CIP with DCC</option>
                      <option value="Yes, DCC only">Yes, DCC only</option>
                      <option value="No">No</option>
                      {/* <option value="Needs HQ approval">Needs HQ approval</option>
                      <option value="Authorized person not available">Authorized person not available</option>
                      <option value="Undecided - for revisit">Undecided - for revisit</option> */}
                    </Form.Select>

                    {isError.joined_maya_program && (
                      <div className="form-error">
                        Please answer if merchant wants to join the Maya Mall Program.
                      </div>
                    )}
                  </Form.Group>

                  {/* Reason for Not Joining (shown when answer is No) */}
                  {primaryDetails.joined_maya_program === "No" && (
                    <Form.Group className="mb-4" controlId="not_joined_maya_program_reason">
                      <Form.Label className="form-label">
                        Reason for not joining Maya Mall Program
                        <span className="form-required">*</span>
                      </Form.Label>
                      <div className="form-radio-group">
                        {reasonOptions.map((reason) => (
                          <div
                            key={reason}
                            className={`form-radio-item ${
                              primaryDetails.not_joined_maya_program_reason === reason ? "selected" : ""
                            }`}
                          >
                            <Form.Check
                              type="radio"
                              name="not_joined_maya_program_reason"
                              value={reason}
                              label={reason}
                              onChange={handleInputChange}
                              checked={primaryDetails.not_joined_maya_program_reason === reason}
                              className="form-radio"
                            />
                          </div>
                        ))}
                      </div>
                      {isError.not_joined_maya_program_reason && (
                        <div className="form-error">
                          Please select a reason for not joining Maya Mall Program.
                        </div>
                      )}
                    </Form.Group>
                  )}

                  {/* Other Reason Text Field */}
                  {primaryDetails.joined_maya_program === "No" && primaryDetails.not_joined_maya_program_reason === "Other reason" && (
                    <Form.Group className="mb-4" controlId="other_not_joining_reason">
                      <Form.Label className="form-label">
                        Other reason for not joining Maya Mall Program <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="other_not_joining_reason"
                        value={primaryDetails.other_not_joining_reason || ""}
                        onChange={handleInputChange}
                        placeholder="Short answer text"
                        className="form-input"
                      />
                    </Form.Group>
                  )}

                  {/* Navigation */}
                  <div className="form-btn-row">
                    <AppButton
                         onClick={handleBack}
                         variant="back"
                         className="form-btn variant-secondary"
                         >
                         ← Back
                        </AppButton>
                     <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                      >
                       Next →
                      </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaMallProgramSection70;
